/* Product cards: show the selected swatch's colour name beside the price.
   Sibling-colour cards render one card with a swatch per colour product; the name
   next to the price (.product__grid__cutline) is the current product's cutline and
   never changed. Desktop: hover/focus previews a colour's name and restores it on
   leave. Touch/click: tapping a swatch (which swaps the image) commits that colour's
   name so it stays. Price is left untouched on purpose (Intelligems rewrites
   .igPrice for price tests). */
(function () {
  if (window.__rbCardSwatchName) return;
  window.__rbCardSwatchName = true;

  var SWATCH = 'a[data-sibling-swatch-link]';

  function infoOf(a) { return a.closest('.product__grid__info'); }
  function cutlineOf(info) { return info && info.querySelector('.product__grid__cutline'); }
  function titleOf(info) {
    var t = info.querySelector('.product__grid__title');
    return t ? t.textContent.trim() : '';
  }
  function nameOf(a, info) {
    var name = (a.getAttribute('title') || '').trim();
    // Swatches fall back to the product title when a colour has no cutline; don't show that.
    if (!name || name === titleOf(info)) return '';
    return name;
  }

  function show(a) {
    var info = infoOf(a), cut = cutlineOf(info);
    if (!cut) return;
    if (info.__rbOrigCutline === undefined) info.__rbOrigCutline = cut.textContent;
    var name = nameOf(a, info);
    if (name) cut.textContent = name;
  }

  // A tap/click selects the colour: make its name the new resting value so the
  // emulated mouseout that follows a tap doesn't put the old name back.
  function commit(a) {
    var info = infoOf(a), cut = cutlineOf(info);
    if (!cut) return;
    var name = nameOf(a, info);
    if (!name) return;
    cut.textContent = name;
    info.__rbOrigCutline = name;
  }

  function reset(a) {
    var info = infoOf(a), cut = cutlineOf(info);
    if (cut && info.__rbOrigCutline !== undefined) cut.textContent = info.__rbOrigCutline;
  }

  function swatchFrom(node) {
    return node && node.closest ? node.closest(SWATCH) : null;
  }

  document.addEventListener('mouseover', function (e) {
    var a = swatchFrom(e.target);
    if (a) show(a);
  });
  document.addEventListener('mouseout', function (e) {
    var a = swatchFrom(e.target);
    if (a && !swatchFrom(e.relatedTarget)) reset(a);
  });
  document.addEventListener('focusin', function (e) {
    var a = swatchFrom(e.target);
    if (a) show(a);
  });
  document.addEventListener('focusout', function (e) {
    var a = swatchFrom(e.target);
    if (a && !swatchFrom(e.relatedTarget)) reset(a);
  });

  // Capture phase so we still run if the theme's own swatch handler stops propagation
  // or prevents the default navigation.
  document.addEventListener('click', function (e) {
    var a = swatchFrom(e.target);
    if (a) commit(a);
  }, true);
  document.addEventListener('touchend', function (e) {
    var a = swatchFrom(e.target);
    if (a) commit(a);
  }, true);
})();
